import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

const ChangePasswordPage = () => {
  const navigate = useNavigate();
  const { changePassword, user } = useAuth();
  const [oldPassword, setOldPassword] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [success, setSuccess] = useState(false);

  const handleChangePassword = async (e) => {
    e.preventDefault();

    if (!newPassword || !confirmPassword) {
      setError('Lütfen tüm alanları doldurun.');
      return;
    }
    if (newPassword !== confirmPassword) {
      setError('Yeni şifreler eşleşmiyor.');
      return;
    }
    if (newPassword.length < 6) {
      setError('Yeni şifre en az 6 karakter olmalıdır.');
      return;
    }

    setIsLoading(true);
    setError('');

    try {
      const passwordData = {
        new_password: newPassword,
        new_password_confirm: confirmPassword,
      };

      if (!user?.must_change_password) {
        if (!oldPassword) {
            setError('Mevcut şifrenizi girmelisiniz.');
            setIsLoading(false);
            return;
        }
        passwordData.old_password = oldPassword;
      }

      const result = await changePassword(passwordData);

      if (result.success) {
        setSuccess(true);
        setTimeout(() => {
          navigate('/module-selection', { replace: true });
        }, 2000);
      } else {
        setError(result.message || 'Şifre değiştirilemedi.');
      }
    } catch (err) {
      setError('Şifre değiştirme sırasında bir hata oluştu.');
    } finally {
      setIsLoading(false);
    }
  };

  if (success) {
    return (
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#f3f4f6', padding: '20px' }}>
        <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)', textAlign: 'center', maxWidth: '420px', width: '100%' }}>
          <div style={{ margin: '0 auto 20px', width: '60px', height: '60px', backgroundColor: '#dcfce7', borderRadius: '50%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <svg style={{ width: '32px', height: '32px', color: '#22c55e' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M5 13l4 4L19 7" /></svg>
          </div>
          <h1 style={{ fontSize: '24px', fontWeight: 'bold', color: '#1f2937', marginBottom: '12px' }}>Başarılı!</h1>
          <p style={{ color: '#6b7280' }}>Şifreniz güncellendi. Proje seçim sayfasına yönlendiriliyorsunuz...</p>
        </div>
      </div>
    );
  }

  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', minHeight: '100vh', backgroundColor: '#f3f4f6', fontFamily: 'sans-serif', padding: '20px' }}>
      <div style={{ backgroundColor: 'white', padding: '40px', borderRadius: '12px', boxShadow: '0 10px 25px rgba(0, 0, 0, 0.1)', width: '100%', maxWidth: '420px' }}>
        <h1 style={{ fontSize: '28px', fontWeight: 'bold', color: '#1f2937', textAlign: 'center', marginBottom: '12px' }}>Şifre Değiştir</h1>
        <p style={{ color: '#6b7280', textAlign: 'center', marginBottom: '32px' }}>
          {user?.must_change_password ? "Güvenliğiniz için yeni bir şifre belirleyin." : "Mevcut şifrenizi değiştirin."}
        </p>

        <form onSubmit={handleChangePassword} noValidate>
          {error && (
            <p style={{ marginBottom: '20px', textAlign: 'center', color: 'red' }}>{error}</p>
          )}

          {!user?.must_change_password && (
            <div style={{ marginBottom: '20px' }}>
              <label htmlFor="old_password" style={{ display: 'block', marginBottom: '8px', color: '#374151', fontWeight: '500' }}>Mevcut Şifre</label>
              <input id="old_password" type="password" value={oldPassword} onChange={(e) => setOldPassword(e.target.value)} placeholder="••••••••" autoComplete="current-password" style={{ width: '100%', padding: '12px 16px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '16px', boxSizing: 'border-box' }} />
            </div>
          )}

          <div style={{ marginBottom: '20px' }}>
            <label htmlFor="new_password" style={{ display: 'block', marginBottom: '8px', color: '#374151', fontWeight: '500' }}>Yeni Şifre</label>
            <input id="new_password" type="password" value={newPassword} onChange={(e) => setNewPassword(e.target.value)} placeholder="••••••••" autoComplete="new-password" style={{ width: '100%', padding: '12px 16px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '16px', boxSizing: 'border-box' }} />
          </div>

          <div style={{ marginBottom: '24px' }}>
            <label htmlFor="confirm_password" style={{ display: 'block', marginBottom: '8px', color: '#374151', fontWeight: '500' }}>Yeni Şifre (Tekrar)</label>
            <input id="confirm_password" type="password" value={confirmPassword} onChange={(e) => setConfirmPassword(e.target.value)} placeholder="••••••••" autoComplete="new-password" style={{ width: '100%', padding: '12px 16px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '16px', boxSizing: 'border-box' }} />
          </div>

          <button type="submit" disabled={isLoading} style={{ width: '100%', padding: '14px', backgroundColor: isLoading ? '#9ca3af' : '#2563eb', color: 'white', border: 'none', borderRadius: '8px', fontSize: '16px', fontWeight: '600', cursor: 'pointer', opacity: isLoading ? 0.6 : 1 }}>
            {isLoading ? 'Değiştiriliyor...' : 'Şifreyi Değiştir'}
          </button>
        </form>
      </div>
    </div>
  );
};

export default ChangePasswordPage;
